import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var NotificationBellSvg = function NotificationBellSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 2c-1.909 0-3.74.76-5.09 2.115a7.24 7.24 0 0 0-2.108 5.107v4.455L2.5 18.297h19l-2.302-4.62V9.222a7.24 7.24 0 0 0-2.108-5.107A7.19 7.19 0 0 0 12 2M7.954 5.163a5.71 5.71 0 0 1 8.092 0 5.75 5.75 0 0 1 1.675 4.06v4.804l1.39 2.788H4.889l1.39-2.788V9.222a5.75 5.75 0 0 1 1.675-4.06",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.154 22h3.691v-1.482h-3.69z"
  }));
};
export var NotificationBell = function NotificationBell(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: NotificationBellSvg
  }));
};